/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-23 12:10 VN — WEB-20261023-suzitee-cart-snapshot
 * Đã làm: file MỚI. Sau khi khách thêm vào giỏ thành công, đọc /cart.js và bắn event Klaviyo "SZ Cart Snapshot"
 * (cả giỏ + ảnh preview Customily + ô khách nhập + add-on) — chạy SHADOW 7 ngày, chưa flow nào dùng.
 * An toàn: KHÔNG bọc/sửa fetch hay XHR — chỉ nghe event 'szmc:open' (src=atc) mà drawer giỏ (sz_minicart.js) bắn SAU KHI
 * thêm giỏ thành công + drawer đã mở; dự phòng PerformanceObserver /cart/add cho lối thêm giỏ không qua drawer.
 * Đợi 1,5s rồi mới làm, nên không chặn nút ATC / drawer giỏ / chuyển trang. Không có Klaviyo hoặc khách chưa nhận diện
 * => thử lại 1 lần sau 3s rồi bỏ qua, không gọi /cart.js. Mọi lỗi nuốt im (try/catch). Không thư viện ngoài. Không có link sửa thiết kế.
 * Gỡ: xoá dòng include sz-cart-snapshot trong layout/theme.liquid. */
(function () {
  try {
    if (!window.PerformanceObserver || !window.fetch) return;
    var ADDON = /Gift Box|Damage-P|Packaging/i, timer = null, KEY = 'szCartSnap';
    function kl() { var k = window.klaviyo; return k && typeof k.isIdentified === 'function' && typeof k.track === 'function' ? k : null; }
    function snap(again) {
      var k = kl();
      if (!k) { if (!again) setTimeout(function () { snap(1); }, 3000); return; }   // Klaviyo tải trễ (chờ tương tác) → thử lại 1 lần
      Promise.resolve(k.isIdentified()).then(function (ok) {
        if (!ok) return;
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
          if (!cart || !cart.items || !cart.items.length) return;
          var items = cart.items.map(function (it) {
            var p = it.properties || {}, opts = [];
            Object.keys(p).forEach(function (n) {
              var v = p[n];
              if (n.charAt(0) !== '_' && v && String(v).indexOf('http') !== 0) opts.push({ name: n, value: String(v).slice(0, 60) });
            });
            return {
              product_id: String(it.product_id), variant_id: String(it.variant_id), title: it.product_title,
              variant_title: it.variant_title || '', quantity: it.quantity, line_price: it.final_line_price / 100,
              url: location.origin + it.url,
              image: it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '',
              preview: p['_customily-preview'] || '', options: opts.slice(0, 4), addon: ADDON.test(it.product_title)
            };
          });
          var sig = JSON.stringify(items.map(function (i) { return [i.variant_id, i.quantity, i.preview]; }));
          try { if (sessionStorage.getItem(KEY) === sig) return; sessionStorage.setItem(KEY, sig); } catch (e) {}
          return k.track('SZ Cart Snapshot', {
            items: items, ProductIDs: items.map(function (i) { return i.product_id; }).join(','),
            ItemCount: cart.item_count, $value: cart.total_price / 100,
            PreviewCount: items.filter(function (i) { return i.preview; }).length,
            CartURL: location.origin + '/cart'
          });
        });
      }).catch(function () {});
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { snap(0); }, 1500); }   // gộp ATC + add-on liền nhau thành 1 event
    document.addEventListener('szmc:open', function (e) { try { if (e.detail && e.detail.src === 'atc') schedule(); } catch (x) {} });
    new PerformanceObserver(function (list) {
      try {
        var es = list.getEntries();
        for (var i = 0; i < es.length; i++) {
          var e = es[i];
          if ((e.initiatorType === 'fetch' || e.initiatorType === 'xmlhttprequest') && /\/cart\/add(\.js)?(\?|$)/.test(e.name.split('#')[0].replace(location.origin, ''))
              && (!e.responseStatus || e.responseStatus < 400)) {
            schedule();
          }
        }
      } catch (x) {}
    }).observe({ type: 'resource' });
  } catch (x) {}
})();
